import React from 'react'
import { IColumn } from '../../../../../utility/types'
import { Flex, Link, PopOver, Span, layout, styled } from '@fareye/ui'
import { parseTemperature } from '@fareye/common'
import { FiInfo, getValueFromNestedKey, isEmpty, startCase } from '@fareye/utils'
import { dateFormatter as formatDate} from '@fareye/common'

const Header: any = styled(Span)`
  width: 100%;
  display: block;
  text-transform: uppercase;
  padding: 0 3px;
  text-align: ${({ align = 'left' }) => align};
  font-family: Lato;
  font-size: 14px;
  font-weight: 600;
  color: #202C39;
`
const CellSpan: any = styled(Span)`
  font-family: 'Lato';
  font-weight: 400;
  font-size: 14px;
  color: #4C5761;
`

const BgSpan = styled(Span)`
  background: ${(props: any) =>
    props.theme.colors[props?.title] || 'rgba(98,90,80,1)'};
  width: min-content;
`

const ColFullHeight = styled((props: any) => (
  <Flex
    p={1}
    justifyContentSpaceEvenly
    column
    {...props}
    style={{
      width: '100%',
      height: '100%',
      padding: '2px 4px',
      ...props.style,
      boxSizing: 'content-box'
    }}
  >
    {props.children}
  </Flex>
))`
  ${layout}
`

const generateColumnObject = (
  column: IColumn,
  { t, links, queryParams = {} }: any
) => {
  const { label, key, formatter, columnConfig } = column
  switch (key) {
    case 'shipmentId':
      return {
        Header: () => (
          <Header data-id={key}>
            {t(label)}
          </Header>
        ),
        id: key,
        width: 160,
        ...columnConfig,
        Cell: ({ row: { original } }: any) => (
          <ColFullHeight>
            <CellSpan variant="ellipsis" title={original.lrNo}>
              <Link
                target="_blank"
                variant="xs"
                to={`${links.tripShare}/${
                  original.slug
                }${queryParams.tripShare || ''}`}
              >
                {t(original.lrNo)}
              </Link>
            </CellSpan>
          </ColFullHeight>
        )
      }
    case 'status':
      return {
        Header: () => <Header>{t(label)}</Header>,
        id: key,
        width: 150,
        ...columnConfig,
        Cell: ({ row: { original } }: any) => {
          return (
            <ColFullHeight>
              <BgSpan
                title={t(original.status.replace(' ', ''))}
                variant="h6"
                style={{ padding: '3px 5px', borderRadius: '6px' }}
                color={'#ffff'}
              >
                {original.status ? t(startCase(original.status)) : '-'}
              </BgSpan>
            </ColFullHeight>
          )
        }
      }
    case 'inState':
      return {
        Header: () => <Header>{t(label)}</Header>,
        id: key,
        width: 150,
        ...columnConfig,
        Cell: ({ row: { original } }: any) => {
          return (
            <ColFullHeight>
              <BgSpan
                title={t(original.inState.replace(' ', ''))}
                variant="h6"
                style={{ padding: '2px 10px', borderRadius: '6px' }}
                color={'#ffff'}
              >
                {original.inState ? t(startCase(original.inState)) : '-'}
              </BgSpan>
            </ColFullHeight>
          )
        }
      }
    case 'stopCount':
      return {
        Header: () => (
          <Header data-id={key}>
            {t(label)}
          </Header>
        ),
        id: key,
        width: 90,
        ...columnConfig,
        Cell: ({ row: { original } }: any) => (
          <ColFullHeight>
            <CellSpan variant="ellipsis" style = {{color: '#4C5761'}}>
              {t(original.stops?.length - 1) || '-'}
            </CellSpan>
          </ColFullHeight>
        )
      }
    case 'currentTemperature':
      return {
        Header: () => (
          <Header data-id={key}>
            {t(label)}
          </Header>
        ),
        id: key,
        width: 140,
        ...columnConfig,
        Cell: ({ row: { original } }: any) => {
          let data = original?.deviceInfo?.extraData || {}
          let value =
            isEmpty(data) ||
            !(
              data?.hasOwnProperty('temperature') ||
              data?.hasOwnProperty('sensorData')
            )
              ? null
              : parseTemperature(
                  original?.deviceInfo?.extraData?.temperature ??
                    original?.deviceInfo?.extraData?.sensorData
                )
          return (
            <ColFullHeight>
              {value ? <CellSpan variant="ellipsis" style = {{color: '#4C5761'}}>{value}&#8451;</CellSpan> : <>-</>}
            </ColFullHeight>
          )
        }
      }
    case 'firstTemperatureVoilationTemperature':
      return {
        Header: () => (
          <Header data-id={key}>
            {t(label)}
          </Header>
        ),
        id: key,
        width: 140,
        ...columnConfig,
        Cell: ({ row: { original } }: any) => {
          let data = original?.firstTemperatureVoilationInfo?.temperature
          let value = data && parseTemperature(data)
          return (
            <ColFullHeight>
              {value ? <CellSpan variant="ellipsis" style = {{color: '#4C5761'}}>{value}&#8451;</CellSpan> : <>-</>}
            </ColFullHeight>
          )
        }
      }
    default:
      return {
        Header: () => (
          <Header data-id={key}>
            {t(label)}
          </Header>
        ),
        id: key,
        width: 150,
        ...columnConfig,
        Cell: ({ row: { original } }: any) => {
          let value = getValueFromNestedKey(original, key)
          return (
            <ColFullHeight>
              <CellSpan variant="ellipsis" style = {{color: '#4C5761'}}>
                {formatter && formatters[formatter]
                  ? formatters[formatter](value) || '-'
                  : value ?? '-'}
              </CellSpan>
            </ColFullHeight>
          )
        }
      }
  }
}

function dateFormatter(val: any) {
  return (val ? formatDate(val, 'hhmmADDMMMMYYYY') : '-')
}

const formatters: any = {
  dateFormatter
}

export const getTableColumns = (
  reqdColumns: IColumn[],
  { t, links, queryParams = {} }: any
) => {
  const result: any = []
  reqdColumns.map(ele => {
    result.push (generateColumnObject(ele, { t, links, queryParams}))
  })
  return result
}